<nz-upload
  nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
  [nzHeaders]="{ authorization: 'authorization-text' }"
  (nzChange)="handleChange($event)"
>
  <button nz-button>
    <i nz-icon nzType="upload"></i>
    点击上传
  </button>
</nz-upload>
